import React from "react";
import Landing from "./Landing";

const NYC = () => <Landing location="NYC · NJ" />;

export default NYC;
